import React, { Component } from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import queryString from "query-string"
import Text from "../s22_text"

const postscribe = typeof window !== "undefined" ? require("postscribe") : null
class Form extends Component {
  state = {
    completed: false,
    loaded: false,
  }

  componentDidMount() {
    const { blok } = this.props

    if (typeof window !== "undefined") {
      const query = queryString.parse(window.location.search)
      const completed = !!(query.aliId && query.aliId !== "")

      if (completed) {
        this.setState({
          completed,
        })
      } else if (postscribe) {
        postscribe(this.instance, blok.embed_code, {
          done: this.onLoad,
        })
      }
    }
  }

  onLoad = () => {
    this.setState({
      loaded: true,
    })
  }

  getFSWrapperClass() {
    const { blok } = this.props
    const { completed, loaded } = this.state

    if (completed) {
      return " fs-wrapper--hidden"
    } else if (!blok._editable && !loaded) {
      return " fs-wrapper--loading"
    }
    return ""
  }

  render() {
    const { blok } = this.props
    const { completed } = this.state

    return (
      <SbEditable content={blok}>
        <>
          <div className={`fs-wrapper${this.getFSWrapperClass()}`}>
            <div ref={(el) => (this.instance = el)} />
          </div>
          <div
            className={`fs-completed-wrapper${
              completed || blok._editable ? " fs-completed-wrapper--done" : ""
            }`}
          >
            {blok.thank_you_copy && blok.thank_you_copy.length && (
              <Text blok={blok.thank_you_copy[0]} />
            )}
          </div>
        </>
      </SbEditable>
    )
  }
}

Form.propTypes = {
  blok: PropTypes.shape({
    embed_code: PropTypes.string,
    thank_you_copy: PropTypes.arrayOf(
      PropTypes.shape({
        copy: PropTypes.string,
      })
    ),
  }).isRequired,
}

export default Form
